import { RecaptchaBranding as MewsRecaptchaBranding } from '@mews/business-components';
import { isRecaptchaServiceInitialized } from '@mews/framework';
import { useAppSelector } from '../../../../utils/redux';
import { getMewsPrivacyPolicyUrl } from '../TermsAndConditions/selectors';

export const RecaptchaBranding = () => {
    const hasRecaptcha = isRecaptchaServiceInitialized(window);

    const mewsPrivacyPolicyUrl = useAppSelector(getMewsPrivacyPolicyUrl);

    return hasRecaptcha ? <MewsRecaptchaBranding mewsPrivacyPolicyUrl={mewsPrivacyPolicyUrl} /> : null;
};
